<template>
    <div class="widget-products__item">
        <div class="widget-products__image image image--type--product">
            <router-link :to="'/part/' + productDetails.manufacturer + '/'+ clearProductName + '/'+ productDetails.itemSeo + '/'+ productDetails.mfgSeo" class="image__body">
                <img class="image__tag" :src="resource_img" alt="">
            </router-link>
        </div>
        <div class="widget-products__info">
            <div class="widget-products__name">
                <router-link :to="'/part/' + productDetails.manufacturer + '/'+ clearProductName + '/'+ productDetails.itemSeo + '/'+ productDetails.mfgSeo">
                    {{productDetails.MCNAME}} {{productDetails.desc}} {{productDetails.IMITMC}}
                    
                </router-link>
            </div>
            <div class="widget-products__prices">
                <div class="widget-products__price widget-products__price--current notranslate">
                    {{toUSD(productDetails.yourprice)}}
                </div>
                <!-- <div class="widget-products__price widget-products__price--old notranslate" v-if="productDetails.old_price > 0">{{toUSD(productDetails.old_price)}}</div> -->
            </div>
        </div>
    </div>
</template>

<script>
import Price from '../../../mixins/price.js';
import CloudinaryApi from '../../../utilities/cloudinaryapi';
import * as GCONST from '../../../constants.js';

export default {
    mixins: [Price],
    props: {
        index: {
            type: Number,
            required: true
        },
        productDetails: {
            type: Object,
            required: true
        },
        productRelated: {
            type: Boolean,
        }
    },

    data() {
        return {
            resource_img: '',
        };
    },

    computed:{
        clearProductName(){
            const clearProductName = encodeURIComponent(this.productDetails.IMITMC);

            return clearProductName;
        },
    },

    created() {
        if(this.productRelated == true) {
            const clApi = new CloudinaryApi;
            clApi.item_sku = this.productDetails.IMITMC;
            clApi.manufacturer_code = this.productDetails.manufacturer;
            
            clApi.vlImageByMeta(GCONST.CL_META_ITEM_SKU, GCONST.Product_Thumbnail).then(imgURL => {
                if(imgURL){
                    this.resource_img = imgURL;
                }else{
                    this.resource_img = GCONST.IMAGE_PLACEHOLDER;
                }
            });
        }else{
            this.resource_img = this.productDetails.image;
        }
    }
}
</script>